import {useEffect, useMemo, useRef, useState} from "react";
import Box from "@mui/material/Box";
import {styled} from "@mui/material/styles";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import {Button, ClickAwayListener, Dialog, DialogContent, Divider, Fab, Grid, Grow, MenuList, Paper, Popper, TextField, Tooltip, Typography} from "@mui/material";
import {Link, useLocation, useNavigate} from "react-router";
import {ButtonColorGradient} from "../theme/theme";
import CloseIcon from '@mui/icons-material/Close';
import "./home.css";
import {BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title} from 'chart.js';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import {FileServerTable} from "../fileServerTable/fileServerTable";
import {TapeDeletion} from "../tapeDeletion/tapes_deletion";
import Usage from "../usage/usage";
import {Add, Person, ShoppingCart} from "@mui/icons-material";
// VpnKey was only used by the hidden Microsoft Sign-in entry below.
// import {VpnKey} from "@mui/icons-material";
import {fetchCustomers} from "../../utils/apiCalls";
import {useAuth} from "../../views/AuthProvider/AuthProvider";
import {useJobContext} from "../../views/JobContextProvider/JobContextProvider";
import moment from "moment";
import {getFormattedProperty} from "../../utils/utils";
import {dynamicTooltipConstruction} from "../DataTable/DataTable";
import {WidgetsGrid} from "../dashboardGrid/widgetsGrid";
import {dashboardLayout} from "./dashboardLayout";
import {WaterfallGraph} from "../widgets/waterfallGraph/waterfallGraph";
import {TreeMapGraph} from "../widgets/treeMapGraph/treeMapGraph";
import {DoubleDonutGraph} from "../widgets/DoubleDonutGraph/DoubleDonutGraph";
import {MediaMetrics} from "../widgets/MediaMetrics/MediaMetrics";
import {fetchDeploymentType, fetchHydrateStatus} from "../../utils/dashboardCalls";
import {SelectAccountDialog, ToggleButton, useStyles} from "../../utils/uiUtils";
import {accountHeadingName} from "../../utils/accountHeading";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Legend
);


export const options = {

    elements: {
        bar: {borderWidth: 2,},
    },
    responsive: true,
    maintainAspectRation: true,
    scales: {
        y: {
            ticks: {
                color: 'white', beginAtZero: true,
                callback: ((context, index) => {
                    // return formatBytes(context)
                    return getFormattedProperty(context, null, 'data_size_iso_units')
                })
            }
        },

        x: {
            barThickness: 1,
            ticks: {color: 'white', beginAtZero: true}
        }
    },

    plugins: {
        title: {
            display: false,
            text: 'Chart.js Bar Chart',
        },
        legend: {display: false},
    },
};

const checkDate = (date) => {
    let check = moment(date, 'YYYY/MM/DD');
    let month = check.format('MM');
    let day = check.format('D');
    let year = check.format('YYYY');
    return {
        day: day,
        month: month,
        year: year
    }
}
// const formatBytes = (bytes, decimals = 0) => {
//     if (!+bytes) return '0'
//
//     const k = 1024
//     const dm = decimals < 0 ? 0 : decimals
//     const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
//
//     const i = Math.floor(Math.log(bytes) / Math.log(k))
//
//     return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
// }
const convertNumberToKMGFormat = (number) => {
    if (number < 1000) {
        return number.toString();
    }
    if (number < 1000000) {
        return (number / 1000).toFixed(1) + "K";
    }
    if (number < 1000000000) {
        return (number / 1000000).toFixed(1) + "M";
    }
    return (number / 1000000000).toFixed(1) + "G";

}
// const totalBoxStaticData = [{
//     icon: '/assets/img/server.svg',
//     data: 0,
//     text: 'File Servers'
// }, {
//     icon: `/assets/img/Users.svg`,
//     data: 0,
//     text: 'Users'
// }, {
//     icon: '/assets/img/Storage.svg',
//     data: 0,
//     text: 'Storage'
// }, {
//     icon: '/assets/img/Critical.svg',
//     data: 0,
//     // text: 'Expiring Files'
//     text: 'Number of Files'
// }
// , {
//     icon: '/assets/img/g30110.svg',
//     data: 0,
//     text: 'Virtual Machines'
// }
// ];
export const Home = () => {
    //TODO: Remove when RBAC implemented
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const {features, isAdmin: authIsAdmin, user} = useAuth();
    const {setSelectorEnabled, jobGroups, selectedCids} = useJobContext();

    /*
     * Who the heading says this dashboard is about.
     *
     * An admin has no company of their own — the API returns company_name as '' for a user with no
     * CustomerUser row — so for them the line names the scope the selector is pointed at instead. See
     * utils/accountHeading; the heading used to print 'Company Name Undefined' here.
     */
    const accountName = useMemo(
        () => accountHeadingName({user, isAdmin: authIsAdmin, jobGroups, selectedCids}),
        [user, authIsAdmin, jobGroups, selectedCids]
    );

    // Home consumes the job context selector — enable it on mount, disable on unmount.
    useEffect(() => {
        setSelectorEnabled(true);
        return () => setSelectorEnabled(false);
    }, [setSelectorEnabled]);
    const [visiblityToggle, setVisiblityToggle] = useState(false);
    const [accountDialog, setAccountDialog] = useState(false);
    const [openFileServer, setOpenFileServer] = useState(false)
    const [clientList, setClientList] = useState([]);
    // const [boxes, setBoxes] = useState(totalBoxStaticData);
    const [page, setPage] = useState(1);
    const [openDropdown, setOpenDropdown] = useState(false)
    const [hasMore, setHasMore] = useState(true)
    const [range, setRange] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        }
    ])
    const [loading, setLoading] = useState({
        totalLoader: true,
        ingestedLoader: true
    });
    const [data, setData] = useState();
    const classes = useStyles();
    // const handleChange = (event, newAlignment) => {
    //     setAlignment(newAlignment);
    // };
    const navigate = useNavigate();
    const Item = styled(Paper)(({theme}) => ({
        backgroundColor: "transparent",
        border: "none",
        boxShadow: "none",
        color: '#fff',
        textAlign: 'left',
    }));

    const getClientList = (fetchPage) => {
        const pageToFetch = fetchPage !== undefined ? fetchPage : page;
        fetchCustomers("", pageToFetch)
            .then(data => {
                if (!data) return;
                const results = Array.isArray(data) ? data : (data.results || []);
                setClientList(prevData => {
                    const merged = pageToFetch === 1 ? results : [...prevData, ...results];
                    return merged.sort((a, b) => (a.company_name || "").localeCompare(b.company_name || ""));
                });
                setPage(pageToFetch + 1);
                setHasMore(results.length > 0);
            })
            .catch(error => console.log(error));
    }
    const [date, setDate] = useState("month");
    const [filter, setFilter] = useState("current_month");
    const handleChangeFilter = (event) => {
        setFilter(event.target.value);
    }
    const handleChange = (event, newAlignment) => {
        setDate(newAlignment);
    };

    // Admin Action menu
    const [adminActionMenuOpen, setAdminActionMenuOpen] = useState(false);
    const anchorRef = useRef(null);

    /*
     * Files focus: the Dashboard Focus selector (Media / Files) is offered only where the deployment has
     * file-level data, so one code base serves both: AWS file-level customers get it, and a deployment without
     * file-level data (Azure, tape-only customers) shows no selector at all rather than a greyed-out button.
     * It was commented out on azuremain on 24 Sep 2026 for Azure alone (docs/file-level-ui-removal.md); the
     * merge into main would have taken it away from AWS too.
     *
     * `isFileLevel` decides whether the selector is shown; `hasFiles` (hydrated) whether Files is clickable.
     * Off the loading wash: the answer only adds a toggle, and the page is usable in Media focus meanwhile.
     * A deployment without file-level data makes one call here, not two.
     */
    const [dashboardFocus, setDashboardFocus] = useState('tapes');
    const [isFileLevel, setIsFileLevel] = useState(false);
    const [hasFiles, setHasFiles] = useState(false);
    const [isLoadingFilesCapability, setIsLoadingFilesCapability] = useState(true);

    useEffect(() => {
        let isMounted = true;
        setIsLoadingFilesCapability(true);

        fetchDeploymentType({background: true})
            .then(response => {
                if (!isMounted) return;
                const deployed_company_id = response?.result?.deployed_company_id;
                const file_level_details = response?.result?.file_level_details;

                if (file_level_details !== 'true') {
                    setIsFileLevel(false);
                    setHasFiles(false);
                    setIsLoadingFilesCapability(false);
                } else {
                    setIsFileLevel(true);
                    fetchHydrateStatus({background: true})
                        .then(response => {
                            if (!isMounted) return;
                            const hydratedFilesStatus = response?.result?.[deployed_company_id]?.state;
                            setHasFiles(hydratedFilesStatus === 'hydrated');
                        })
                        .catch(error => {
                            if (isMounted) console.error("Error fetching hydrate status:", error);
                            setHasFiles(false);
                        })
                        .finally(() => {
                            if (isMounted) setIsLoadingFilesCapability(false);
                        });
                }
            })
            .catch(error => {
                if (isMounted) {
                    console.error("Error fetching deployment type:", error);
                    setIsFileLevel(false);
                    setHasFiles(false);
                    setIsLoadingFilesCapability(false);
                }
            });

        return () => { isMounted = false; };
    }, []);

    const handleAdminActionMenuToggle = () => {
        setAdminActionMenuOpen((prevOpen) => !prevOpen);
    };

    const handleAdminActionMenuClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setAdminActionMenuOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setAdminActionMenuOpen(false);
        } else if (event.key === 'Escape') {
            setAdminActionMenuOpen(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = useRef(adminActionMenuOpen);
    useEffect(() => {
        if (prevOpen.current === true && adminActionMenuOpen === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = adminActionMenuOpen;

    }, [adminActionMenuOpen]);
    // useEffect(() => {
    //     // getTotalData();
    //     // getIngestionData();
    // }, []);
    const [clientValue, setClientValue] = useState('')
    const handlechangeClientList = (e) => {
        setClientValue(e.target.value)
    }
    const handleContinue = (uuid) => {
        navigate(`/JobCreation`,
            {
                state: {
                    "uuid": uuid,
                    "step": 1,
                    "iscomingFrom": "customerSelection"
                }
            });
    }
    const openAccountDialog = () => {
        getClientList(1);
        setAccountDialog(true);
    }
    const isAdmin = authIsAdmin;
    // const getTotalData = (_isAdmin) => {
    //     updateLoadingState('totalLoader', true);
    //     let payload = {
    //         type: 'rep_total',
    //         "request": {
    //             cid: getCID(),
    //             "type": "totals"
    //         }
    //     };
    //     axios.post(totals, payload)
    //         .then(response => {
    //             if (response?.status == 200) {
    //                 let accountTotals = {};
    //                 if (!_isAdmin) {
    //                     accountTotals = response?.data?.result?.data;
    //                 } else {
    //                     accountTotals = response?.data?.result;
    //                 }
    //
    //                 // let labels = response?.data?.body?.map((e) => e.name);
    //                 let data = [{
    //                     icon: '/assets/img/server.svg',
    //                     data: accountTotals['server-count'],
    //                     text: 'File Servers',
    //                     path: '/FileServer'
    //                 }, {
    //                     icon: `/assets/img/Users.svg`,
    //                     data: accountTotals['company-users'],
    //                     text: 'Users',
    //                     path: undefined
    //                 }, {
    //                     icon: '/assets/img/Storage.svg',
    //                     data: getFormattedProperty(accountTotals, 'total-storage', 'data_size_iso_units'),
    //                     text: 'Storage',
    //                     tooltip: [{name: "Bytes", ui_class: "data_size_bytes", value: accountTotals['total-storage']}, {name: "IEC std.", ui_class: "data_size_iec_units", value: accountTotals['total-storage']}],
    //                     path: undefined
    //                 }, {
    //                     icon: '/assets/img/Critical.svg',
    //                     data: convertNumberToKMGFormat(accountTotals['file-count']),
    //                     text: 'Number of Files',
    //                     path: undefined
    //                 }
    //                 ];
    //                 setBoxes(data);
    //                 updateLoadingState('totalLoader', false);
    //             }
    //         })
    //         .catch(error => {
    //             console.log(error)
    //             updateLoadingState('totalLoader', false);
    //
    //         });
    // }
    // const getIngestionData = (_isAdmin) => {
    //     updateLoadingState('ingestedLoader', true);
    //     let payload = {
    //         "type": "rep_ingest",
    //         "request": {
    //             cid: getCID(),
    //             "type": "ingested-timeline"
    //         }
    //     };
    //     axios.post(ingested, payload)
    //         .then(response => {
    //             if (response?.status == 200) {
    //                 let _allMonthData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    //                 let labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Sep', 'Oct', 'Nov', 'Dec'];
    //                 let dynamicArray;
    //                 let dynamicObject;
    //                 if (!_isAdmin) {
    //                     dynamicObject = Object.values(response.data.result)
    //                     dynamicObject.forEach(i =>
    //                         dynamicArray = i.data)
    //                     dynamicArray.forEach(element => {
    //                         let _date = checkDate(element['ingest_date']);
    //
    //                         _allMonthData[_date.month - 1] = _allMonthData[_date.month - 1] + element?.bytes;
    //
    //                         if (!labels[_date.month - 1]?.includes(_date.year))
    //                             labels[_date.month - 1] = labels[_date.month - 1] + "-" + _date.year;
    //                     });
    //                     let _data = {
    //                         labels: labels,
    //                         datasets: [
    //                             {
    //                                 label: '',
    //                                 data: _allMonthData,
    //                                 // borderWidth: 0,
    //                                 categoryPercentage: 1,
    //                                 backgroundColor: [
    //                                     "rgba(56, 170, 88, 1) ",
    //                                     "rgba(0, 126, 35, 1) ",
    //                                     "rgba(56, 170, 88, 1)",
    //                                     "rgba(0, 126, 35, 1)",
    //                                     // "rgba(189, 95, 95, 1) "
    //                                 ],
    //                                 borderWidth: 1,
    //                                 barPercentage: 0.4,
    //                                 borderRadius: 4
    //                             }
    //
    //                         ],
    //
    //                     };
    //                     setData(_data)
    //                     updateLoadingState('ingestedLoader', false);
    //                 } else {
    //                     dynamicArray = [];
    //                     dynamicObject = Object.values(response.data.result)
    //                     dynamicObject.forEach(i => {
    //                         if (i && i.data) {
    //                             dynamicArray = dynamicArray.concat(i.data)
    //                         }
    //                     })
    //                     dynamicArray.forEach(element => {
    //                         let _date = checkDate(element['ingest_date']);
    //
    //                         _allMonthData[_date.month - 1] = _allMonthData[_date.month - 1] + element?.bytes;
    //
    //                         if (!labels[_date.month - 1]?.includes(_date.year))
    //                             labels[_date.month - 1] = labels[_date.month - 1] + "-" + _date.year;
    //                     });
    //                     let _data = {
    //                         labels: labels,
    //                         datasets: [
    //                             {
    //                                 label: '',
    //                                 data: _allMonthData,
    //                                 // borderWidth: 0,
    //                                 categoryPercentage: 1,
    //                                 backgroundColor: [
    //                                     "rgba(56, 170, 88, 1) ",
    //                                     "rgba(0, 126, 35, 1) ",
    //                                     "rgba(56, 170, 88, 1)",
    //                                     "rgba(0, 126, 35, 1)",
    //                                     // "rgba(189, 95, 95, 1) "
    //                                 ],
    //                                 borderWidth: 1,
    //                                 barPercentage: 0.4,
    //                                 borderRadius: 4
    //                             }
    //
    //                         ],
    //
    //                     };
    //                     setData(_data)
    //                     updateLoadingState('ingestedLoader', false);
    //                 }
    //             }
    //         })
    //         .catch(error => {
    //             console.log(error)
    //             updateLoadingState('ingestedLoader', false);
    //         });
    // }
    const updateLoadingState = (widgetName, isLoading) => {
        setLoading((prevLoader) => ({
            ...prevLoader, [widgetName]: isLoading
        }));
    }

    const handleClientScroll = (e) => {
        const {target} = e
        e.stopPropagation()
        // if (target.scrollHeight - target.scrollTop == target.clientHeight && hasMore)
        getClientList()
    }
    const handleSelect = (ranges) => {
        setRange([
            ranges.selection
        ])
    }
    const toggleVisiblityOfCalendar = () => {
        let _visiblityToggle = !visiblityToggle;
        setVisiblityToggle(_visiblityToggle)
    }

    const getHomeTopCardComponent = (item) => {
        const getValueContent = () => {
            if (item?.tooltip) {
                return (
                    <Tooltip title={dynamicTooltipConstruction(null, item.tooltip)} slotProps={{tooltip: {className: "wideTooltip"},}}>
                        {item.data}
                    </Tooltip>
                );
            } else {
                return item.data;
            }
        }

        return (
            <Typography variant="h5" component="div" sx={{fontSize: 24}} color="text.secondary" gutterBottom className="dashboardConatiner">
                {getValueContent()}
            </Typography>
        );
    };

    /*
     * The graph widgets, in layout order.
     *
     * Declared as a list rather than passed straight to WidgetsGrid because the dashboard reads as a
     * two-by-two: Media Metrics beside the first graph, the rest on the row below. So the first entry is
     * pulled out and rendered next to the counters, and the two that follow share the second row.
     *
     * The Files focus (file-level deployments only, see above) puts the two file graphs in front of the donuts.
     */
    const graphWidgets = dashboardFocus === 'files'
        ? [
            {component: TreeMapGraph, title: 'Age of Files', variant: 'ageOfFilesData'},
            {component: TreeMapGraph, title: 'Data Type', variant: 'filesTypeData'},
            {component: DoubleDonutGraph, title: 'Backup Data', variant: 'backup'},
            {component: DoubleDonutGraph, title: 'Storage Policies', variant: 'storagePolicies'},
        ]
        : [
            /*
             * headingInside: the heading goes to the widget rather than to the frame around it, because the
             * design puts the period tabs above it and the frame always draws its title first. See
             * widgetsGrid, which skips its own heading when handed an empty title.
             */
            {
                component: WaterfallGraph,
                title: 'Data Ingestion Overview',
                variant: 'ingestedData',
                headingInside: true,
            },
            {component: DoubleDonutGraph, title: 'Backup Data', variant: 'backup'},
            {component: DoubleDonutGraph, title: 'Storage Policies', variant: 'storagePolicies'},
        ];
    const [leadGraph, ...trailingGraphs] = graphWidgets;

    /*
     * Empty graphs give their space to the Media Metrics card; the rules are in dashboardLayout. Each graph
     * reports through its `onDataState`, and a hidden one stays mounted (WidgetsGrid `hidden`, display:none
     * here) so that a change of job can bring it back.
     */
    const [graphStates, setGraphStates] = useState({});
    const dataStateReporters = useMemo(() => Object.fromEntries(
        graphWidgets.map(({variant}) => [variant, state =>
            setGraphStates(previous => previous[variant] === state ? previous : {...previous, [variant]: state})])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [dashboardFocus]);
    const layout = dashboardLayout(graphStates, leadGraph.variant, trailingGraphs.map(({variant}) => variant));

    return (
        /*
         * Vertical padding dropped entirely, horizontal left alone.
         *
         * The dashboard is meant to fit one screen — counters above, graphs below, no scrolling — and this
         * box sits inside `.outLet`, which already pads 20px all round. The old p={4} was therefore a
         * second 32px of margin stacked on the first, 64px of the height budget spent twice over on empty
         * space. The side margins are not part of the problem and stay as they were, so the page keeps its
         * width and only loses the vertical slack.
         *
         * The rest of the budget: the min-height fix on `.outLet` in App.css, the density block in
         * MediaMetrics.jsx, and the height cap in widgetsGrid.jsx.
         */
        <Box pl={10} pr={10}>
            {openFileServer ? <Grid item>
                    <Grid container direction='row' justifyContent='space-between' spacing={2}>
                        <FileServerTable/>
                    </Grid>
                </Grid> :
                <Grid container direction='column' spacing={1.5}>
                    <Grid item>
                        <Grid container direction='row' justifyContent='space-between'>
                            <Grid item>
                                <Typography
                                    align='left'
                                    className={classes.mainHeading}
                                    style={{
                                        fontWeight: 700,
                                        fontSize: '20px',
                                        color: "#fff"
                                    }}>
                                    {/* No 'Account:' clause at all when there is no account to name, rather
                                        than a placeholder standing in for one. */}
                                    {accountName ? `Account: ${accountName} ` : ''}(User: {user?.first_name !== '' || user?.last_name !== '' ? `${user?.last_name} ${user?.first_name}` : user?.username})
                                </Typography>
                            </Grid>
                            {/*<Grid item>*/}
                            {/*    <Grid container direction="row" justifyContent="flex-end">*/}
                            {/*        <Grid item className={classes.toggleContainer}>*/}
                            {/*            <Paper elevation={1} sx={{*/}
                            {/*                border: '1px solid #FFC540',*/}
                            {/*                display: 'flex',*/}
                            {/*                background: 'transparent',*/}
                            {/*                flexWrap: 'wrap',*/}
                            {/*                padding: 0.5,*/}
                            {/*            }}>*/}
                            {/*                <ToggleButtonGroup*/}
                            {/*                    color="primary"*/}
                            {/*                    value={filter}*/}
                            {/*                    exclusive*/}
                            {/*                    onChange={(e) => setFilter(e.target.value)}*/}
                            {/*                    aria-label="Platform"*/}
                            {/*                >*/}
                            {/*                    <ToggleButton value="current_month">This Month</ToggleButton>*/}
                            {/*                    <ToggleButton value="last_month">Last Month</ToggleButton>*/}
                            {/*                    <ToggleButton value="current_year">This Year</ToggleButton>*/}
                            {/*                    <ToggleButton value="custom_date" onClick={toggleVisiblityOfCalendar} sx={{*/}
                            {/*                        cursor: 'pointer'*/}
                            {/*                    }}>Custom Date</ToggleButton>*/}
                            {/*                    /!* <LocalizationProvider dateAdapter={AdapterMoment}>*/}
                            {/*                        <DemoContainer>*/}
                            {/*                            <DateRangePicker name="allowedRange" />*/}
                            {/*                        </DemoContainer>*/}
                            {/*                    </LocalizationProvider> *!/*/}

                            {/*                </ToggleButtonGroup>*/}
                            {/*            </Paper>*/}
                            {/*            {*/}
                            {/*                filter == 'custom_date' && visiblityToggle ?*/}
                            {/*                    <DateRange*/}
                            {/*                        editableDateInputs={true}*/}
                            {/*                        onChange={handleSelect}*/}
                            {/*                        moveRangeOnFirstSelection={false}*/}
                            {/*                        ranges={range}*/}
                            {/*                    /> : ""*/}
                            {/*            }*/}
                            {/*        </Grid>*/}
                            {/*    </Grid>*/}
                            {/*</Grid>*/}
                        </Grid>

                    </Grid>

                    {/*<Grid item>*/}
                    {/*    <Grid container direction='row' justifyContent='space-between' spacing={2}>*/}
                    {/*        {boxes.map((item, index) => (*/}
                    {/*            <Grid item md key={`${item.path}-${index}`}>*/}
                    {/*                <Card variant="outlined"*/}
                    {/*                      className="dashboardGridBg"*/}
                    {/*                      sx={{*/}
                    {/*                          cursor: item.path ? 'pointer' : undefined*/}
                    {/*                      }}*/}
                    {/*                      onClick={item.path ? () => navigate(item.path) : () => {*/}
                    {/*                      }}*/}
                    {/*                >*/}
                    {/*                    <CardContent className="dashboardGrid" style={loading.totalLoader ? {*/}
                    {/*                        position: 'relative',*/}
                    {/*                        opacity: '0.2'*/}
                    {/*                    } : {}}>*/}
                    {/*                        {*/}
                    {/*                            loading.totalLoader ?*/}
                    {/*                                <CircularProgress style={{*/}
                    {/*                                    position: 'absolute',*/}
                    {/*                                    top: '50%',*/}
                    {/*                                    left: '50%',*/}
                    {/*                                    transform: 'translate(-50%, -50%)'*/}
                    {/*                                }}/> : ""*/}
                    {/*                        }*/}
                    {/*                        <Typography>*/}
                    {/*                            <div style={{*/}
                    {/*                                height: '60px', width: '60px', display: 'flex',*/}
                    {/*                                alignItems: 'center',*/}
                    {/*                                justifyContent: 'center',*/}
                    {/*                                margin: 'auto'*/}
                    {/*                            }}>*/}
                    {/*                                <img src={item.icon} alt=""/>*/}
                    {/*                            </div>*/}
                    {/*                        </Typography>*/}
                    {/*                        {getHomeTopCardComponent(item)}*/}
                    {/*                        <Typography variant="h5" component="div" sx={{fontSize: 14}} color="white" className="dashboardText">*/}
                    {/*                            {item.text}*/}
                    {/*                        </Typography>*/}
                    {/*                    </CardContent>*/}
                    {/*                </Card>*/}
                    {/*            </Grid>*/}
                    {/*        ))}*/}
                    {/*    </Grid>*/}
                    {/*</Grid>*/}

                    {/* Files focus: the Dashboard Focus selector, on file-level deployments only (see the state above). */}
                    {isFileLevel && (
                        <Grid item xs="auto">
                            <Box display="flex" flexDirection="column" alignItems="flex-start">
                                <Typography variant="h5" sx={{fontSize: 16}} color="white"> Dashboard Focus </Typography>
                                <Paper
                                    elevation={1}
                                    sx={{mt: 0.5, border: '1px solid #FFC540', background: 'transparent', p: 0.5, display: 'inline-flex', width: 'fit-content'}}
                                >
                                    <ToggleButtonGroup
                                        color="primary"
                                        value={dashboardFocus}
                                        exclusive
                                        onChange={e => setDashboardFocus(e.target.value)}
                                        aria-label="Dashboard Focus Selector"
                                    >
                                        {[{value: 'tapes', label: 'Media'}, {value: 'files', label: 'Files'}].map(({value, label}) => (
                                            <ToggleButton
                                                key={value}
                                                value={value}
                                                sx={{lineHeight: 1.1, minWidth: 'auto !important', minHeight: 'auto !important', textTransform: 'none', fontSize: '0.75rem'}}
                                                disabled={value === 'files' && (isLoadingFilesCapability || !hasFiles)}
                                            >
                                                {label}
                                            </ToggleButton>
                                        ))}
                                    </ToggleButtonGroup>
                                </Paper>
                            </Box>
                        </Grid>
                    )}

                    {/*
                      * Top row: the counters and the first graph, side by side.
                      *
                      * Both halves are told to fill the row, not to size it — `alignItems="stretch"` makes
                      * the two columns equal, the Media Metrics card stretches into its half and the graph
                      * takes its height from the row rather than from its own width. That is what lines the
                      * two up along the bottom edge; before this the graph derived a height from its width
                      * and the shorter of the two just stopped early, leaving the pair visibly ragged.
                      *
                      * The counters are still what decide how tall the row is, being the only side with an
                      * intrinsic height. Grow the card and the graph follows it.
                      */}
                    <Grid item sx={{width: '100%', minWidth: 0}}>
                        <Grid container spacing={1.5} alignItems="stretch">
                            <Grid item xs={12} lg={layout.mediaMetricsFullWidth ? 12 : 6}
                                  sx={{minWidth: 0, display: 'flex'}}>
                                {/*
                                  * Was also stretched to 80% of the window when every graph was empty, to take
                                  * the bottom row's room. Switched off on review (2 Nov 2026): the tiles spread
                                  * out to fill it and the card read as mostly gaps. It widens only.
                                  *   sx={{..., ...(layout.mediaMetricsFullHeight ? {minHeight: '80vh'} : {})}}
                                  */}
                                <MediaMetrics/>
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{display: layout.leadGraphHidden ? 'none' : 'flex', minWidth: 0}}>
                                <WidgetsGrid
                                    fillHeight
                                    widgets={[leadGraph.component]}
                                    titles={[leadGraph.headingInside ? '' : leadGraph.title]}
                                    variants={[leadGraph.variant]}
                                    widgetProps={[{
                                        ...(leadGraph.headingInside ? {heading: leadGraph.title} : {}),
                                        onDataState: dataStateReporters[leadGraph.variant],
                                    }]}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    {/*
                      * Bottom row: whatever graphs are left, sharing it.
                      *
                      * No height imposed, so each takes the size its width implies — which for the two
                      * donut charts is what they need for the totals to sit inside the ring and for the
                      * legend underneath to be readable. Squeezing this row into the leftover viewport was
                      * tried first and cost exactly those two things, so the row keeps its size and the
                      * page scrolls to reach it.
                      */}
                    <Grid item sx={{width: '100%', minWidth: 0, ...(layout.bottomRowHidden ? {display: 'none'} : {})}}>
                        <WidgetsGrid
                            widgets={trailingGraphs.map(({component}) => component)}
                            titles={trailingGraphs.map(({title, headingInside}) => headingInside ? '' : title)}
                            variants={trailingGraphs.map(({variant}) => variant)}
                            widgetProps={trailingGraphs.map(({title, headingInside, variant}) => ({
                                ...(headingInside ? {heading: title} : {}),
                                onDataState: dataStateReporters[variant],
                            }))}
                            hidden={layout.trailingGraphsHidden}
                        />
                    </Grid>

                    <Grid item style={{
                        display: 'none'
                    }}>
                        <Grid container direction='row' justifyContent='space-between' spacing={2}>
                            <Grid item xs={6}>
                                <TapeDeletion/>
                            </Grid>
                            <Grid item xs={6}>
                                <Usage/>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>}

            {/* Admin Actions */}
            {features.length > 0 && (
                <Fab
                    ref={anchorRef}
                    id="admin-action-button"
                    aria-controls={adminActionMenuOpen ? 'admin-action-menu' : undefined}
                    aria-expanded={adminActionMenuOpen ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleAdminActionMenuToggle}
                    sx={{
                        position: 'fixed',
                        bottom: 16,
                        right: 16,
                        '&.MuiFab-root': {
                            background: ButtonColorGradient,
                        },
                        visibility: (isAdmin) ? 'visible' : 'hidden',
                        cursor: 'pointer'
                    }}
                >
                    <Add/>
                </Fab>
            )}
            <Popper
                open={adminActionMenuOpen}
                anchorEl={anchorRef.current}
                role={undefined}
                placement="bottom-end"
                transition
                disablePortal
            >
                {({TransitionProps, placement}) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === 'right bottom',
                        }}
                    >
                        <Paper sx={{backgroundColor: '#3A3E3F', border: '1px solid #FFFFFF', borderRadius: '8px'}}>
                            <ClickAwayListener onClickAway={handleAdminActionMenuClose} sx={{
                                cursor: 'pointer'
                            }}>
                                <MenuList
                                    autoFocusItem={adminActionMenuOpen}
                                    id="admin-action-menu"
                                    aria-labelledby="admin-action-button"
                                    onKeyDown={handleListKeyDown}
                                >

                                    <MenuItem sx={{p: 2, gap: 2,}}>
                                        <Person sx={{color: '#FFFFFF'}}/>
                                        <Link to="/AccountCreation" style={{textDecoration: 'none'}}>
                                            <Typography sx={{fontFamily: 'Poppins', color: '#FFFFFF'}}>Account Creation</Typography>
                                        </Link>
                                    </MenuItem>
                                    <Divider sx={{my: 0.5, backgroundColor: '#FFFFFF'}}/>
                                    <MenuItem sx={{p: 2, gap: 2, cursor: 'pointer'}} onClick={openAccountDialog}>
                                        <ShoppingCart sx={{color: '#FFFFFF'}}/>
                                        <Typography sx={{fontFamily: 'Poppins', color: '#FFFFFF'}}>Job Creation</Typography>
                                    </MenuItem>
                                    {/*
                                      * Hidden, not deleted: Microsoft's approval is now the customer's to give, so Tape Ark no longer sends it.
                                      * See the /MicrosoftSignIn route in App.js.
                                      *
                                      * Its own entry rather than a field on Account Creation, because the company
                                      * usually exists before anyone decides it should use Entra sign-in - a
                                      * Marketplace purchase creates one without going near that form.
                                      */}
                                    {/*
                                    <Divider sx={{my: 0.5, backgroundColor: '#FFFFFF'}}/>
                                    <MenuItem sx={{p: 2, gap: 2}}>
                                        <VpnKey sx={{color: '#FFFFFF'}}/>
                                        <Link to="/MicrosoftSignIn" style={{textDecoration: 'none'}}>
                                            <Typography sx={{fontFamily: 'Poppins', color: '#FFFFFF'}}>Microsoft Sign-in</Typography>
                                        </Link>
                                    </MenuItem>
                                    */}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
            <SelectAccountDialog
                open={accountDialog}
                onClose={() => { setAccountDialog(false); setPage(1); }}
                customers={clientList}
                onConfirm={handleContinue}
            />
        </Box>

    );
};

function TabsStepIcon() {
    const [alignment, setAlignment] = useState("web");
    const handleChange = (event, newAlignment) => {
        setAlignment(newAlignment);
    };
    return (
        <>
            <ToggleButtonGroup
                color="primary"
                value={alignment}
                exclusive
                onChange={handleChange}
                aria-label="Platform"
            >
                <ToggleButton value="web"> Month</ToggleButton>
                <ToggleButton value="android"> Year</ToggleButton>
            </ToggleButtonGroup>
        </>
    );
}